import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import Icon from "components/Icons/Icon";

function AssetLogsWrapper({ companyId }) {
  const darkMode = useSelector(state => state.app.darkMode);

  return (
    <>
      <div className={darkMode ? "darkMode" : ""}>
        <Link
          to={`/companies/company/${companyId}/assets/logs`} 
          className="d-flex align-items-center mr-1"
        >
          <Button variant="outline-secondary" className={`${darkMode ? "btn-primary" : "btn-light"} dropdown-label`}>
            <span className='d-flex align-items-baseline'><Icon className="fas fa-tasks mr-1"/>Logs</span>
          </Button>
        </Link>
      </div>
    </>
  )
}

export default AssetLogsWrapper
